export type CouponAudience = 'PUBLIC' | 'FOUNDER';
export type DiscountType = 'PERCENTAGE' | 'FIXED_AMOUNT';
export type CouponDuration = 'ONCE' | 'REPEATING' | 'FOREVER';
export type ModuleKey = 'BOOKING' | 'ONLINE_PAYMENTS' | 'INVENTORY';

export interface IAdminCoupon {
  id?: number;
  code?: string;
  description?: string | null;
  audience?: CouponAudience;
  discountType?: DiscountType;
  discountValue?: number;
  duration?: CouponDuration;
  durationInCycles?: number | null;
  appliesToModuleKey?: ModuleKey | null;
  maxRedemptions?: number | null;
  timesGranted?: number;
  timesRedeemed?: number;
  redeemableFrom?: string | null;
  redeemableUntil?: string | null;
  active?: boolean;
  createdDate?: string | null;
  lastModifiedDate?: string | null;
  lastModifiedBy?: string | null;
}

export const defaultValue: Readonly<IAdminCoupon> = {
  audience: 'PUBLIC',
  discountType: 'PERCENTAGE',
  duration: 'ONCE',
  active: true,
};
